<template>
    <div class="main-content">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h4>Статистика рецептов</h4>

                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th></th>
                                <th>ID</th>
                                <th>Препарат</th>
                                <th>Врач</th>
                                <th>Клиент</th>
                                <th>Дата рецепта</th>
                                <th>Номер рецепта</th>
                                <th>Дата создания</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(record, index) in records">
                                <td>{{(index + 1) + ((paginator.current_page - 1) * paginator.per_page)}}</td>
                                <td>{{record.prep_id}}</td>
                                <td>{{record.prep.prep}}</td>
                                <td>{{record.doctor.name}} ({{record.doctor.specialty}})</td>
                                <td>{{record.client.name}} {{record.client.surname}}</td>
                                <td>{{record.template_date}}</td>
                                <td>{{record.template_number}}</td>
                                <td>{{record.created_at}}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="text-right">
                            <paginate v-if="paginator"
                                      :page-count="paginator.last_page"
                                      :page-range="3"
                                      :margin-pages="2"
                                      :click-handler="getStatistic"
                                      :prev-text="'&laquo'"
                                      :next-text="'&raquo'"
                                      :container-class="'pagination'"
                                      :prev-class="'page-item'"
                                      :prev-link-class="'page-link'"
                                      :page-class="'page-item'"
                                      :page-link-class="'page-link'"
                                      :next-class="'page-item'"
                                      :next-link-class="'page-link'"
                                      :active-class="'active green_btn'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>

    .text-rigth{
        padding-right: 10px;
    }
    .pagination{
        justify-content: flex-end;
    }

</style>

<script>

    import api from '@/api'
    import Paginate from 'vuejs-paginate'

    export default {
        components: {
            Paginate,
        },
        data() {
            return {
                records: null,
                paginator: null
            }
        },
        mounted() {
            this.getStatistic()
        },
        methods: {
            clickPage(page) {
                console.log(page)
            },
            async getStatistic(page = null) {
                let {data: r_data} = await api.index('/receipts/getStatistics?page=' + page)
                const {data, ...pagination} = r_data.records
                this.paginator = pagination
                this.records = data
            }
        }
    }

</script>